import React, { useEffect, useState } from 'react'
import axios from 'axios'

// Components
import Picker from 'emoji-picker-react'
import Message from './components/message'
import { ThemeProvider } from '@material-ui/core'
import { createTheme } from '@material-ui/core/styles'
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete'
import TextField from '@material-ui/core/TextField'
import IconButton from '@material-ui/core/IconButton'
import DialogTitle from '@material-ui/core/DialogTitle'
import Dialog from '@material-ui/core/Dialog'
import Grid from '@material-ui/core/Grid'
import Button from '@material-ui/core/Button'
import Chip from '@material-ui/core/Chip'
import Badge from '@material-ui/core/Badge'


// Media
import CloseIcon from '@material-ui/icons/Close'
import CheckIcon from '@material-ui/icons/CheckOutlined'
import CopyIcon from '@material-ui/icons/FileCopyOutlined'
import AddIcon from '@material-ui/icons/AddOutlined'
import Logo from './logos/logo/main.svg'
import LogoAbove from './logos/logo_above/blue.svg'
import ArrowAnimated from './media/arrow_animated.svg'

// Stylesheets
import './App.css'

const filter = createFilterOptions();

const theme = createTheme({
  palette: {
    primary: {
      main: '#FFFFFF',
    },
    secondary: {
      main: '#F7529E',
    }
  }
})

const api = axios.create({
  withCredentials: process.env.NODE_ENV === 'production',
  baseURL: process.env.NODE_ENV === 'production' ? `https://api.afino.io/${process.env.REACT_APP_BASE_URL}/slack/` : `http://localhost:8080/${process.env.REACT_APP_BASE_URL}/slack/`
});

const params = new URLSearchParams(window.location.search);
var authed = false;

function alert_before_close(e) {
  e.preventDefault();
  return (e.returnValue = 'Are you sure you want to close?');
}

var adding = false;

const SlackButton = () => {
  return (
  <a href="https://slack.com/oauth/v2/authorize?client_id=1097380764085.2037553580481&scope=app_mentions:read,channels:join,channels:manage,channels:read,chat:write,commands,files:read,groups:read,groups:write,im:history,im:read,im:write,mpim:history,mpim:read,mpim:write,team:read,users.profile:read,users:read,files:write&user_scope="><img alt="Add to Slack" height="40" width="139" src="https://platform.slack-edge.com/img/add_to_slack.png" srcSet="https://platform.slack-edge.com/img/add_to_slack.png 1x, https://platform.slack-edge.com/img/add_to_slack@2x.png 2x" /></a>
  )
}

const custom_examples = [
  { emoji: '🔮', text: "Most Impactful Advice I've Received" },
  { emoji: '🗺', text: 'Favourite Destination' },
  { emoji: '🧑‍🍳', text: 'Favourite meal' },
  { emoji: '🌎', text: 'Language(s) Spoken' },
  { emoji: '🐕', text: 'My Pet(s)' },
  { emoji: '🗞', text: 'My First Ever Job' },
  { emoji: '☕️', text: 'Coffee Or Tea' },
  { emoji: '📖', text: 'I Recently Read' },
  { emoji: '🎬', text: 'I Recently Watched' },
  { emoji: '🏝', text: 'Three Items I Would Bring To A Desert Island' },
  { emoji: '📜', text: 'A Historical Figure I Would Want To Meet' },
  { emoji: '🍽', text: "Best Meal I've Ever Had?" },
  { emoji: '🦉', text: 'Early Bird Or Night Owl?' },
  { emoji: '🧑‍🍳', text: 'Favorite Recipe' },
  { emoji: '🪣', text: 'Three Things On My Bucket List?' },
  { emoji: '🦹', text: 'If I Had A Superpower It Would Be' },
]


function App() {
  const [view, setView] = useState(0);
  const [invite_modal, setInvite_modal] = useState(false);
  const [help, setHelp] = useState({});
  const [error, setError] = useState();
  const [token, setToken] = useState();
  const [channels, setChannels] = useState([]);
  const [selected_channels, setSelected_channels] = useState([]);
  const [custom, setCustom] = useState([])
  const [customText, setCustomText] = useState(null)
  const [customEmoji, setCustomEmoji] = useState('')
  const [pickEmoji, setPickEmoji] = useState(false)
  const [copied, setCopied] = useState(false)
  const [email, setEmail] = useState('')
    
  useEffect(() => {
    var animationInterval = setInterval(() => {
      if (authed) {
        clearInterval(animationInterval);
        setView(3);
      }
    }, 1000);

    if (params.has('code')) {
      setView(1);
      api
        .post('oauth', {
          code: params.get('code')
        })
        .then(res => {
          if (res.data.ok) {
            window.addEventListener('beforeunload', alert_before_close);
            authed = true;
            setChannels(res.data.channels);
            setToken(res.data.token);
          } else {
            setError(res.data.message);
            setView('error');
          }
        })
        .catch(() => {
          setView('error');
        });
    }
  }, [window.location.search]);
  
  const copy_invite = () => {
    navigator.clipboard.writeText("/invite @Afino")
    setCopied(true)
    setTimeout(() => {
      setCopied(false)
    }, 2000)
  }
  
  const addCustom = () => {
    if (!customText) return setHelp({ text: 'Please write something to add' })
    setCustom([...custom, `${customEmoji ? `${customEmoji} ` : ''}${customText}`])
    setCustomText('')
    setCustomEmoji('')
  }

  const handleCustomSelect = (e, newValue) => {
    if (newValue && typeof newValue == 'object') {
      setCustomText(newValue.text);
      setCustomEmoji(newValue.emoji);
    } else {
      setCustomText(newValue)
    }
    setPickEmoji(false)
  }
  
  const emojiSelected = (e, emojiObj) => {
    setCustomEmoji(emojiObj.emoji)
    setPickEmoji(false)
  }

  const add_channels = (from_modal) => {
    if (adding) return;
    if (selected_channels.length == 0 && !from_modal) {
      setInvite_modal(true);
      return
    }
    var setup = {
      channels: selected_channels,
      custom,
      email
    };
    adding = true;
    api
      .post('setup', {
        setup,
        token
      })
      .then(res => {
        window.removeEventListener('beforeunload', alert_before_close);
        if (res.data.ok) {
          setView(6);
        } else {
          adding = false;
          setError(res.data.message);
          setView('error');
        }
      })
      .catch(() => {
        adding = false;
        window.removeEventListener('beforeunload', alert_before_close);
        setView('error');
      });
  };

  return (
    <ThemeProvider theme={theme}>
      <div className="App">
        <Message message={help.text} duration={help.duration} color={help.color} onClose={setHelp} />
        <header className="App-header">
          {view === 0 && (
            <>
              <img alt="Afino" className="logo" src={LogoAbove} />
              <SlackButton />
            </>
          )}
          {view === 1 && (
            <div className="heading loading">Adding you to our systems</div>
          )}
          {view === 2 && (
            <div className="fade-in">
              <div className="heading">Welcome to Afino for Slack.</div>
              <div className="sub-heading">where remote teams THRIVE</div>
              <object className="logo" style={{ padding: 40 }} type="image/svg+xml" data={Logo}></object>
              <div onClick={() => setView(3)} className="arrow-container">
                <object className="animated-arrow" type="image/svg+xml" data={ArrowAnimated}>
                  Next
                </object>
              </div>
            </div>
          )}
          {view === 3 && (
            <div className="fade-in">
              <div className="heading">Customize</div>
              <div className="sub-heading">Add custom field to your team's Afino Cards</div>
              <div style={{ width: 'calc(100% - 82px)', maxWidth: 650, display: 'inline-block', margin: '20px 0' }}>
                <Grid container spacing={2}>
                  <Grid item xs={3} sm={2}>                      
                    <Badge
                      badgeContent={customEmoji ?
                        <IconButton size="small" style={{ backgroundImage: 'linear-gradient(to top right, #F7529E, #FA8F58)' }} onClick={() => {setCustomEmoji('')}}>
                          <CloseIcon style={{ fontSize: 14 }} />
                        </IconButton> : <></>
                      }
                    >
                      <TextField 
                        label="Emoji"
                        variant="outlined"
                        onClick={() => setPickEmoji(true)}
                        value={customEmoji}
                        onChange={({ target }) => setCustomEmoji(target.value)}
                        InputLabelProps={{ shrink: true }}
                        InputProps={{ readOnly: true, style: { color: '#fff' } }}
                      />
                    </Badge>
                  </Grid>
                  <Grid item xs={9} sm={10}>
                    <Autocomplete
                      freeSolo
                      selectOnFocus
                      autoSelect
                      handleHomeEndKeys
                      value={customText}
                      onChange={handleCustomSelect}
                      filterOptions={(options, params) => {
                        const filtered = filter(options, params);                  
                        const { inputValue } = params;
                        // Suggest the creation of a new value
                        const isExisting = options.some((option) => inputValue === option);
                        if (inputValue !== '' && !isExisting) {
                          filtered.push({
                            label: `Add "${inputValue}"`,
                            text: inputValue
                          });
                        }
                        return filtered.filter((el) => (!custom.some((cust) => (cust == `${el.emoji} ${el.text}`))));
                      }}
                      getOptionLabel={(option) => {
                        // Value selected with enter, right from the input
                        if (typeof option === 'string') {
                          return option;
                        }
                        // Add "xxx" option created dynamically
                        if (option.label) {
                          return option.label;
                        }
                        // Regular option
                        return option.text;
                      }}
                      options={custom_examples}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          InputLabelProps={{ shrink: true }}
                          variant="outlined"
                          label="Type Here"
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} style={{ alignSelf: 'center' }}>
                    <Button
                      style={{ backgroundImage: 'linear-gradient(to top right, #F7529E, #FA8F58)' }}
                      fullWidth
                      color="primary"
                      endIcon={<AddIcon />}
                      onClick={addCustom}
                    >
                      Add
                    </Button>
                  </Grid>
                </Grid>
              </div><br />
              {custom.map((cust, ind) => (
                <Chip 
                  key={cust}
                  size="small"
                  style={{ margin: 5, color: '#fff', backgroundImage: 'linear-gradient(to top right, #F7529E, #FA8F58)' }}
                  label={cust}
                  clickable
                  onDelete={() => setCustom(custom.filter((el, index) => (index != ind)))}
                  deleteIcon={<CloseIcon style={{ color: '#fff' }} />}
                />
              ))}
              <Dialog onClose={() => setPickEmoji(false)} aria-labelledby="Pick an emoji" open={pickEmoji}>
                <div style={{ padding: 25, paddingTop: 0 }}>
                  <Picker onEmojiClick={emojiSelected} />
                </div>
              </Dialog>
              <br />
              <div className="slack-card">
                <Grid container className="slack-card-header">
                  <Grid item xs={2}>
                    <img className="slack-card-avatar" src="https://avatars.slack-edge.com/2021-06-17/2208094729232_793f76dd3239f83abc85_72.png" />
                  </Grid>
                  <Grid item xs={9}>
                    Card
                  </Grid>
                  <Grid item xs={1}>
                    <CloseIcon />
                  </Grid>
                </Grid>
                <Grid container className="slack-card-body">
                  <Grid item xs={4}>
                    👤 Afino <span style={{ fontStyle: 'italic' }}>(They/Them)</span>
                  </Grid>
                  <Grid item xs={4}>
                    💼 Human Connection
                  </Grid>
                  <Grid item xs={4}>
                    📍 The Ocean
                  </Grid>
                  <Grid item xs={4}>
                    <span className="bold">🗣 Talk To Me About</span><br />
                    <span className="slack-code">Swimming</span>&#32;<span className="slack-code">Remote Work</span>&#32;<span className="slack-code">Yourself</span>
                  </Grid>
                  <Grid item xs={5}>
                    <span className="bold">💪 Can Help With</span><br />
                    <span className="slack-code">1-on-1's</span>&#32;<span className="slack-code">Collaboration</span>&#32;<span className="slack-code">Introducing New Hires</span>
                  </Grid>
                  <Grid item xs={2}>
                    <img className="slack-card-avatar" style={{ height: 80 }} src="https://afino-app.s3.amazonaws.com/static/Logo_Afino.png" />
                  </Grid>
                </Grid>
                <Grid container className="slack-card-body">
                  <Grid item xs={12}>
                    <span className="bold">🎯 What I'm Working Towards</span><br />Building stronger remote teams by driving meaningful connections
                  </Grid>
                  {custom.map((q) => (
                    <Grid item xs={12}>
                      <span className="bold">{q}</span><br />Answer Here
                    </Grid>
                  ))}
                </Grid>
                <Grid container className="slack-card-body">
                  <Grid item xs={12}>
                    <span className="bold" style={{ lineHeight: 2 }}>
                      <a href="https://www.linkedin.com/company/afino-io" target="_blank" rel="noreferrer">LinkedIn</a>&nbsp;|&nbsp;
                      <a href="https://www.twitter.com/afinohq" target="_blank" rel="noreferrer">Twitter</a>&nbsp;|&nbsp;
                      <a href="https://www.instagram.com/afino.io" target="_blank" rel="noreferrer">Instagram</a>
                    </span>
                  </Grid>
                </Grid>
              </div>
              <div style={{ fontSize: 12 }}>You can also add these in Slack later</div>
              <div onClick={() => setView(4)} className="arrow-container">
                <object className="animated-arrow" type="image/svg+xml" data={ArrowAnimated}>
                  Next
                </object>
              </div>
            </div>
          )}
          {view === 4 && (
            <div className="fade-in">
              <div className="heading">Admin Email</div>
              <div className="sub-heading">
                What email can we reach you at?
              </div>
              <div className="channel-container">
                <TextField 
                  label="Email"
                  variant="outlined"
                  value={email}
                  onChange={({ target }) => setEmail(target.value)}
                  InputLabelProps={{ shrink: true }}
                  InputProps={{ style: { color: '#fff' } }}
                />
              </div>
              <div className="sub-heading" style={{ fontSize: 14, maxWidth: 550, display: 'inline-block' }}>Important Afino updates will be emailed here</div><br />
              <div onClick={() => setView(5)} className="arrow-container">
                <object className="animated-arrow" type="image/svg+xml" data={ArrowAnimated}>
                  Next
                </object>
              </div>
            </div>
          )}
          {view === 5 && (
            <div className="fade-in">
              <div className="heading">Pick Channels</div>
              <div className="sub-heading">
                Everyone within the chosen channel(s) will be prompted to fill out a card.<br />
                New teammates joining these channels later will also be introduced!
              </div>
              <div className="channel-container">
                <Autocomplete
                  multiple
                  onChange={(e, value) => setSelected_channels(value)}
                  options={channels}
                  getOptionLabel={(option) => option.name}
                  filterSelectedOptions
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      variant="outlined"
                      label="Pick Channels"
                    />
                  )}
                />
              </div>
              <div className="sub-heading" style={{ fontSize: 14, maxWidth: 550, display: 'inline-block' }}>Don't see your channel here? Leave blank and click next for instructions.</div><br />
              <Dialog onClose={() => setInvite_modal(false)} aria-labelledby="Add Afino to a channel from Slack" open={invite_modal}>
                <DialogTitle id="simple-dialog-title">Add Afino to a channel</DialogTitle>
                <div style={{ padding: 25, paddingTop: 0 }}>
                  Invite Afino by typing&nbsp;
                  <Chip
                    size="small"
                    style={{ color: '#fff', backgroundImage: 'linear-gradient(to top right, #F7529E, #FA8F58)' }}
                    label="/invite @Afino"
                    clickable
                    onClick={copy_invite}
                    onDelete={copy_invite}
                    deleteIcon={copied ? <CheckIcon style={{ color: '#fff' }} /> : <CopyIcon style={{ color: '#fff' }} />}
                  />
                  &nbsp;in a channel
                </div>
                <Button variant="primary" onClick={() => add_channels(true)} style={{ color: '#fff', margin: '0 25px', marginBottom: 20, backgroundImage: 'linear-gradient(to top right, #F7529E, #FA8F58)' }}>Next</Button>
              </Dialog>
              <div onClick={() => add_channels()} className="arrow-container">
                <object className="animated-arrow" type="image/svg+xml" data={ArrowAnimated}>
                  Next
                </object>
              </div>
            </div>
          )}
          {view === 6 && (
            <div className="fade-in">
              <div className="heading">All Done</div>
              <div className="sub-heading">Let's get started!</div>
              <a style={{ display: 'inline-block' }} href="https://slack.com/app_redirect?app=A0213G9H2E5" target="_blank" rel="noreferrer">
                <div className="meet-button">Meet Afino</div>
              </a>
              {/*<div onClick={() => setView(4)} className="arrow-container">
                <object className="animated-arrow flipped" style={{ marginRight: 0 }} type="image/svg+xml" data={ArrowAnimated}>
                  animated-arrow
                </object>
              </div>*/}
            </div>
          )}
          {view === 'error' && (
            <>
              <div className="heading">Sorry we ran into an error</div>
              <div className="sub-heading">{error || 'There was an issue adding to your Slack. Please try again'}</div><br />
              <SlackButton />
            </>
          )}
        </header>
      </div>
    </ThemeProvider>
  );
}

export default App;
